/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 31:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Class representing the linked products functionality for product finishes
 * Handles hover interactions to display different product finish information
 */

function debounce(fn, wait) {
  var _this = this;
  var t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this, args);
    }, wait);
  };
}
var NewLinkedProducts = /*#__PURE__*/function () {
  /**
   * Create a new NewLinkedProducts instance and initialize it
   */
  function NewLinkedProducts() {
    _classCallCheck(this, NewLinkedProducts);
    this.init();
  }

  /**
   * Cache DOM elements needed for the functionality
   * Stores references to the list heading and finish elements
   * Decodes and stores the original heading text
   */
  return _createClass(NewLinkedProducts, [{
    key: "cacheDomElements",
    value: function cacheDomElements() {
      var _this$listHeading;
      // Get the main heading element
      this.listHeading = document.querySelector('[js-linked-products-new-list-heading]');
      // Get all finish elements and convert NodeList to Array
      this.finishes = Array.from(document.querySelectorAll('[data-finish-name]'));
      // Get and decode the original heading text, fallback to empty string if not found
      this.originalText = decodeURIComponent(((_this$listHeading = this.listHeading) === null || _this$listHeading === void 0 ? void 0 : _this$listHeading.dataset.originalText) || '');
      this.swatchInputs = _toConsumableArray(document.querySelectorAll('.linked-products-new .swatch-input__wrapper'));
    }

    /**
     * Handle mouseover events on finish elements
     * Updates the heading text to show the hovered finish name
     * @param {Event} event - The mouseover event object
     */
  }, {
    key: "handleMouseover",
    value: function handleMouseover(finish, event) {
      var targ = event.currentTarget ? event.currentTarget : finish;
      var finishName = decodeURIComponent(targ.dataset.finishName);
      this.updateHeadingText(finishName);
    }

    /**
     * Handle mouseout events on finish elements
     * Restores the heading text to its original value
     */
  }, {
    key: "handleMouseout",
    value: function handleMouseout() {
      this.updateHeadingText(this.originalText);
    }
  }, {
    key: "handleSwatchMouseover",
    value: function handleSwatchMouseover(swatch, event) {
      var targ = event.currentTarget ? event.currentTarget : swatch;

      /* Get data variant sku and value from input descendant element and log it */
      var variantSku = targ.querySelector('.swatch-input__input--new').dataset.variantSku;
      var serialNumber = targ.querySelector('.swatch-input__input--new').dataset.serialNumber;
      var weight = targ.querySelector('.swatch-input__input--new').dataset.weight;
      var val = targ.querySelector('input').value;
      var closetHeading = targ.closest('fieldset').querySelector('.linked-products-new__list-heading span');
      var isColorOrSize = targ.classList.contains('swatch-input__wrapper--color') || targ.classList.contains('swatch-input__wrapper--size');
      if (variantSku && val && val != 'Default') {
        closetHeading.innerHTML = "".concat(serialNumber ? serialNumber : val, " ").concat(isColorOrSize ? '' : "/ ".concat(weight));
      } else if (val && val == 'Default') {
        closetHeading.innerHTML = document.querySelector('[data-selected-value]').innerHTML = "".concat(val);
      }
    }
  }, {
    key: "handleSwatchMouseout",
    value: function handleSwatchMouseout(event) {
      _toConsumableArray(document.querySelectorAll('[data-selected-value]')).forEach(function (el) {
        var targ = event.currentTarget ? event.currentTarget : el;
        if (targ.classList.contains('swatch-input__wrapper--color') || targ.classList.contains('swatch-input__wrapper--size')) {
          el.innerHTML = el.dataset.swatchOriginalText.split('/').shift();
        } else {
          el.innerHTML = el.dataset.swatchOriginalText;
        }
      });
    }

    /**
     * Update the heading element's text content
     * @param {string} text - The new text to display in the heading
     */
  }, {
    key: "updateHeadingText",
    value: function updateHeadingText(text) {
      if (this.listHeading) {
        this.listHeading.innerHTML = text;
      }
    }

    /**
     * Bind mouseover and mouseout event listeners to finish elements
     * Skips if no finish elements are found
     */
  }, {
    key: "bindEventListeners",
    value: function bindEventListeners() {
      if (!this.finishes.length) return;

      // Create a container reference for checking bounds
      var container = document.querySelector('.linked-products-new');

      // Bind event handlers to preserve context
      var boundMouseover = this.handleMouseover.bind(this);
      var boundMouseout = this.handleMouseout.bind(this);
      var boundSwatchMouseover = this.handleSwatchMouseover.bind(this);
      var boundSwatchMouseout = this.handleSwatchMouseout.bind(this);

      // Add event listeners to each finish element
      this.finishes.forEach(function (finish) {
        // Use mousemove instead of mouseenter to prevent re-triggering
        finish.addEventListener('mousemove', function (e) {
          // Only trigger if mouse is within container bounds
          var containerRect = document.querySelector('.linked-products-new').getBoundingClientRect();
          if (e.clientY >= containerRect.top && e.clientY <= containerRect.bottom) {
            debounce(boundMouseover, 100)(finish, e);
          }
        });
        finish.addEventListener('mouseleave', debounce(boundMouseout, 100));
      });

      // Similar approach for swatches
      this.swatchInputs.forEach(function (swatch) {
        swatch.addEventListener('mousemove', function (e) {
          debounce(boundSwatchMouseover, 50)(swatch, e);
        });
        swatch.addEventListener('mouseleave', debounce(boundSwatchMouseout, 50));
      });
    }

    /**
     * Initialize the component by caching DOM elements and binding events
     */
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      this.cacheDomElements();
      this.bindEventListeners();
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        _this2.reInit();
      });
    }
  }, {
    key: "reInit",
    value: function reInit() {
      this.destroy();
      this.init();
    }

    /**
     * Clean up by removing all event listeners
     * Should be called when the component is no longer needed
     */
  }, {
    key: "destroy",
    value: function destroy() {
      var boundMouseover = this.handleMouseover.bind(this);
      var boundMouseout = this.handleMouseout.bind(this);
      var boundSwatchMouseover = this.handleSwatchMouseover.bind(this);
      var boundSwatchMouseout = this.handleSwatchMouseout.bind(this);

      // Remove all event listeners
      this.finishes.forEach(function (finish) {
        finish.removeEventListener('mousemove', boundMouseover);
        finish.removeEventListener('mouseleave', boundMouseout);
      });
      this.swatchInputs.forEach(function (swatch) {
        swatch.removeEventListener('mousemove', boundSwatchMouseover);
        swatch.removeEventListener('mouseleave', boundSwatchMouseout);
      });
    }
  }]);
}();
/* harmony default export */ __webpack_exports__.A = (NewLinkedProducts);

/***/ }),

/***/ 244:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Represents a product accordion component.
 * This class handles the creation and behavior of accordion elements on a product page.
 */
var ProductAccordion = /*#__PURE__*/function () {
  /**
   * Create a ProductAccordion.
   * @param {string} [selector='.product__accordion .accordion__link'] - The CSS selector for accordion triggers.
   */
  function ProductAccordion() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.product__accordion .accordion__link';
    _classCallCheck(this, ProductAccordion);
    /** @type {Element[]} */
    this.accordions = _toConsumableArray(document.querySelectorAll(selector));
  }

  /**
   * Initialize the accordion functionality.
   * This method sets up event listeners for each accordion trigger.
   */
  return _createClass(ProductAccordion, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Check if any accordion elements were found
      if (!this.accordions.length) {
        console.warn('No accordion elements found');
        return;
      }

      // Add click event listeners to each accordion trigger
      this.accordions.forEach(function (trigger) {
        trigger.addEventListener('click', _this.handleAccordionClick.bind(_this));
      });
    }

    /**
     * Handle the click event on an accordion trigger.
     * @param {Event} event - The click event object.
     */
  }, {
    key: "handleAccordionClick",
    value: function handleAccordionClick(event) {
      event.preventDefault();
      var trigger = event.currentTarget;
      this.scrollToAccordion(trigger);
    }

    /**
     * Scroll to the accordion content associated with the clicked trigger.
     * @param {Element} trigger - The accordion trigger element that was clicked.
     */
  }, {
    key: "scrollToAccordion",
    value: function scrollToAccordion(trigger) {
      // Get the target ID from the trigger's href attribute
      var targetId = trigger.getAttribute('href');
      if (!targetId) {
        console.error('No target ID found for accordion trigger');
        return;
      }

      // Find the target element in the DOM
      var target = document.querySelector(targetId);
      if (!target) {
        console.error("Target element not found: ".concat(targetId));
        return;
      }

      // Calculate the target's position and scroll to it smoothly
      var targetTop = target.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    }
  }]);
}();
/* harmony default export */ __webpack_exports__.A = (ProductAccordion);

/***/ }),

/***/ 1483:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Class to handle styling of Shopify installment payment terms
 */
var InstallmentStyler = /*#__PURE__*/function () {
  function InstallmentStyler() {
    _classCallCheck(this, InstallmentStyler);
    // Common styles to apply
    this.commonStyles = {
      color: '#000',
      fontFamily: 'Inter Tight',
      fontSize: '12px',
      lineHeight: '15px',
      letterSpacing: '0',
      fontWeight: '400'
    };

    // Elements that require styling
    this.elementsToStyle = ['p', 'button', 'span', '.font-bold'];
  }

  /**
   * Initialize the styler
   */
  return _createClass(InstallmentStyler, [{
    key: "init",
    value: function init() {
      try {
        this.findElements();
        this.applyStyles();
      } catch (error) {
        console.log('Error initializing InstallmentStyler:', error);
      }
    }

    /**
     * Find required DOM elements
     */
  }, {
    key: "findElements",
    value: function findElements() {
      // Query the parent element
      this.installmentRoot = document.querySelector('[id^="product-form-installment-template--"] shopify-payment-terms');
      if (!this.installmentRoot) {
        var error = new Error('Installment root element not found.');
        console.log("".concat(error));
        return;
      }

      // Get the shadow root
      this.installmentShadow = this.installmentRoot.shadowRoot;
      if (!this.installmentShadow) {
        var _error = new Error('Shadow root not found on the installment element.');
        console.log("".concat(_error));
        return;
      }

      // Query child container within shadow root
      this.newInstallmentShadow = this.installmentShadow.querySelector('#shopify-installments-content');
      if (!this.newInstallmentShadow) {
        var _error2 = new Error('"#shopify-installments-content" not found in the shadow root.');
        console.log("".concat(_error2));
        return;
      }
    }

    /**
     * Apply styles to elements
     */
  }, {
    key: "applyStyles",
    value: function applyStyles() {
      var _this = this;
      // Apply common styles to elements
      this.elementsToStyle.forEach(function (selector) {
        if (!_this.installmentShadow) return;
        var element = _this.installmentShadow.querySelector(selector);
        if (element) {
          Object.assign(element.style, _this.commonStyles);
        }
      });

      // Handle inline flex element
      if (!this.newInstallmentShadow) return;
      var inlineFlex = this.newInstallmentShadow.querySelector('.inline-flex');
      if (inlineFlex) {
        inlineFlex.style.color = 'initial';
      }

      // Replace SVG with text
      var count = 0;
      var flexSVGInterval = setInterval(function () {
        count++;
        var inlineFlexSVG = _this.newInstallmentShadow.querySelector('.inline-flex svg');
        if (inlineFlexSVG) {
          if (!window.payWidgetTextHasBeenReplaced) {
            inlineFlex.replaceWith(document.createTextNode('Shop Pay.'));
            window.payWidgetTextHasBeenReplaced = true;
          }
          inlineFlexSVG.style.display = 'none';
          document.querySelectorAll('.product-new__installment-container').forEach(function (element) {
            element.classList.remove('loading');
          });
          clearInterval(flexSVGInterval);
        } else if (count > 10) {
          clearInterval(flexSVGInterval);
        }
      }, 100);
    }
  }]);
}();
/* harmony default export */ __webpack_exports__.A = (InstallmentStyler);

/***/ }),

/***/ 4477:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @typedef {Object} CollapsibleRowElements
 * @property {HTMLElement[]} rows - Array of collapsible row elements
 * @property {HTMLElement[]} readMoreLinks - Array of "read more" trigger elements
 * @property {HTMLElement[]} readLessLinks - Array of "read less" trigger elements
 */
/**
 * Manages collapsible content rows with read more/less functionality
 *
 */
var CollapsibleRow = /*#__PURE__*/function () {
  function CollapsibleRow() {
    var _this = this;
    _classCallCheck(this, CollapsibleRow);
    /**
     * @private
     * @type {CollapsibleRowElements}
     */
    _defineProperty(this, "elements", {
      rows: [],
      readMoreLinks: [],
      readLessLinks: []
    });
    /**
     * Handle read more click
     * @private
     * @param {Event} event
     */
    _defineProperty(this, "handleReadMore", function (event) {
      try {
        event.preventDefault();
        var target = event.target;
        if (!target) return;
        var row = target.closest('.collapsible-row-block');
        if (!row) return;
        var contentId = target.getAttribute('js-trigger');
        var content = row.querySelector("#".concat(contentId));
        var innerContent = row.querySelector('.collapsible-row-accordion__content-inner');
        var readLessButton = row.querySelector('[js-trigger-read-less]');
        if (!content || !innerContent || !readLessButton) return;
        _this.toggleElements([{
          element: content,
          class: 'hidden'
        }, {
          element: innerContent,
          class: 'hidden'
        }, {
          element: target,
          class: 'hidden'
        }]);
        readLessButton.classList.remove('hidden');
      } catch (error) {
        console.error('Error handling read more:', error);
      }
    });
    /**
     * Handle read less click
     * @private
     * @param {Event} event
     */
    _defineProperty(this, "handleReadLess", function (event) {
      try {
        event.preventDefault();
        var target = event.target;
        if (!target) return;
        var row = target.closest('.collapsible-row-block');
        if (!row) return;
        var innerContent = row.querySelector('.collapsible-row-accordion__content-inner');
        var readMoreButton = row.querySelector('[js-trigger]');
        if (!innerContent || !readMoreButton) return;
        _this.toggleElements([{
          element: innerContent,
          class: 'hidden'
        }, {
          element: target.parentElement,
          class: 'hidden'
        }, {
          element: target,
          class: 'hidden'
        }]);
        readMoreButton.classList.remove('hidden');
      } catch (error) {
        console.error('Error handling read less:', error);
      }
    });
    try {
      this.init();
    } catch (error) {
      console.error('Failed to initialize CollapsibleRow:', error);
    }
  }

  /**
   * Initialize the component
   * @private
   */
  return _createClass(CollapsibleRow, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.cacheElements();
      if (this.validateElements()) {
        this.addEventListeners();
        setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this2.truncateText();
                setTimeout(function () {
                  _this2.removeLoading();
                }, 0);
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })), 0);
      }
    }

    /**
     * Remove loading class
     * @private
     */
  }, {
    key: "removeLoading",
    value: function removeLoading() {
      this.elements.rows.map(function (row) {
        if (!row.querySelector('.loading')) return;
        row.querySelector('.loading').classList.remove('loading');
      });
    }

    /**
     * Cache DOM elements
     * @private
     */
  }, {
    key: "cacheElements",
    value: function cacheElements() {
      this.elements.rows = Array.from(document.querySelectorAll('.collapsible-row'));
      this.elements.readMoreLinks = this.elements.rows.map(function (row) {
        return row.querySelector('[js-trigger]');
      }).filter(Boolean);
      this.elements.readLessLinks = this.elements.rows.map(function (row) {
        return row.querySelector('[js-trigger-read-less]');
      }).filter(Boolean);
    }

    /**
     * Validate required elements exist
     * @private
     * @returns {boolean}
     */
  }, {
    key: "validateElements",
    value: function validateElements() {
      if (!this.elements.rows.length) {
        console.warn('No collapsible rows found');
        return false;
      }
      if (!this.elements.readMoreLinks.length || !this.elements.readLessLinks.length) {
        console.warn('Missing required trigger elements');
        return false;
      }
      return true;
    }

    /**
     * Truncate text content if exceeds limit
     * @private
     */
  }, {
    key: "truncateText",
    value: function truncateText() {
      var characterLimit = CollapsibleRow.CHARACTER_LIMIT;
      var _iterator = _createForOfIteratorHelper(this.elements.rows),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          try {
            if (this.shouldSkipTruncation(row)) continue;

            // Cache DOM queries
            var content = row.querySelector('[js-content-inner-text]');
            if (!content) continue;
            var readToggle = row.querySelector('.collapsible-row-accordion__read-toggle');
            if (!readToggle) continue;

            // Get all text-containing elements in sequence
            var textElements = Array.from(content.querySelectorAll('p, li'));
            if (!textElements.length) continue;

            // Check if content has already been truncated (has ellipsis)
            var hasEllipsis = content.textContent.includes('...');

            // If content is already truncated and read toggle is visible, skip processing
            if (hasEllipsis && !readToggle.classList.contains('hidden')) {
              continue;
            }
            var runningCount = 0;
            var limitExceeded = false;

            // Iterate through all text elements sequentially
            for (var i = 0; i < textElements.length; i++) {
              var element = textElements[i];
              if (runningCount + element.textContent.length > characterLimit) {
                // Truncate this element
                element.textContent = this.truncateString(element.textContent, characterLimit - runningCount);
                limitExceeded = true;

                // Remove all subsequent elements
                // If the element is a list item, we need to handle parent list cleanup
                textElements.slice(i + 1).forEach(function (el) {
                  if (el.tagName.toLowerCase() === 'li') {
                    el.remove();
                    // If this was the last li in the list, remove the empty ul
                    var parentUl = el.parentElement;
                    if (parentUl && !parentUl.querySelector('li')) {
                      parentUl.remove();
                    }
                  } else {
                    el.remove();
                  }
                });
                break;
              }
              runningCount += element.textContent.length;
            }

            // Show/hide read toggle based on whether truncation occurred
            if (limitExceeded) {
              readToggle.classList.remove('hidden');
            } else {
              readToggle.classList.add('hidden');
            }
          } catch (error) {
            console.error('Error truncating text:', error);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * Check if row should skip truncation
     * @private
     * @param {HTMLElement} row
     * @returns {boolean}
     */
  }, {
    key: "shouldSkipTruncation",
    value: function shouldSkipTruncation(row) {
      var shouldSkip = row.parentNode.classList.contains('product-new__details-blocks') && window.innerWidth > CollapsibleRow.DESKTOP_BREAKPOINT;
      return shouldSkip;
    }

    /**
     * Truncate string with ellipsis
     * @private
     * @param {string} text
     * @param {number} charactersLeft
     * @returns {string}
     */
  }, {
    key: "truncateString",
    value: function truncateString(text, charactersLeft) {
      return "".concat(text.substring(0, charactersLeft), "...");
    }
  }, {
    key: "toggleElements",
    value:
    /**
     * Toggle multiple elements' classes
     * @private
     * @param {Array<{element: HTMLElement, class: string}>} elements
     */
    function toggleElements(elements) {
      elements.forEach(function (_ref2) {
        var element = _ref2.element,
          className = _ref2.class;
        element.classList.toggle(className);
      });
    }

    /**
     * Add event listeners
     * @private
     */
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this3 = this;
      this.elements.readMoreLinks.forEach(function (link) {
        link.addEventListener('click', _this3.handleReadMore);
      });
      this.elements.readLessLinks.forEach(function (link) {
        link.addEventListener('click', _this3.handleReadLess);
      });
    }
  }]);
}();
/** @type {number} */
_defineProperty(CollapsibleRow, "CHARACTER_LIMIT", 665);
/** @type {number} */
_defineProperty(CollapsibleRow, "DESKTOP_BREAKPOINT", 990);
/* harmony default export */ __webpack_exports__.A = (CollapsibleRow);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/* harmony import */ var _snippets_product_accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(244);
/* harmony import */ var _snippets_new_linked_products__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31);
/* harmony import */ var _snippets_collapsible_row__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4477);
/* harmony import */ var _snippets_pay_widgets_pdp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1483);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @fileoverview ProductInfo class handles initialization of product specific enhancements
 * including accordions, linked products, and styling shopify payment terms.
 * @module ProductInfo
 */





/**
 * Class representing product information enhancements.
 */
var ProductInfo = /*#__PURE__*/function () {
  /**
   * Creates an instance of ProductInfo and initializes the product information enhancements.
   * @constructor
   */
  function ProductInfo() {
    _classCallCheck(this, ProductInfo);
  } // try {
  //   this.init();
  // } catch (error) {
  //   console.error('Error initializing ProductInfo:', error);
  // }

  /**
   * Initialize the product info enhancements, including product accordions and linked products.
   * Also applies required styling for the Shopify payment terms.
   * @private
   * @returns {void}
   */
  return _createClass(ProductInfo, [{
    key: "init",
    value: function init() {
      this.initializeAccordion();
      this.initializeLinkedProducts();
      this.applyShopifyPaymentTermsStyling();
      this.initializeCollapsibleRows();
      this.initializeProductDescriptionLinks();
      this.initializeInstallmentStyler();
      this.initializeMoreVariants();
    }
  }, {
    key: "initializeMoreVariants",
    value: function initializeMoreVariants() {
      this.initializeMoreVariantsTrigger();
    }
  }, {
    key: "initializeInstallmentStyler",
    value: function initializeInstallmentStyler() {
      var installmentStyler = new _snippets_pay_widgets_pdp__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A();
      if (typeof installmentStyler.init === 'function') {
        setTimeout(function () {
          return installmentStyler.init();
        }, 800);
      } else {
        console.warn('InstallmentStyler does not have an init method.');
      }
    }
  }, {
    key: "initializeMoreVariantsTrigger",
    value: function initializeMoreVariantsTrigger() {
      var moreVariantsTrigger = document.querySelector('[data-more-variants-trigger]');
      if (moreVariantsTrigger) {
        moreVariantsTrigger.addEventListener('click', this.handleMoreVariantsTriggerClick);
      }
    }
  }, {
    key: "handleMoreVariantsTriggerClick",
    value: function handleMoreVariantsTriggerClick(event) {
      event.preventDefault();

      // Prevent multiple modals from being created
      if (!document.querySelector('serialisation-modal')) return;

      // Get the template from the DOM
      var template = document.querySelector('[data-id="serialisation-modal-template"]');
      if (!template) {
        console.warn('Serialisation modal template not found');
        return;
      }

      // Clone the template content
      template.classList.toggle('hidden');
      /* trigger modal refresh */
      var serialisationModal = document.querySelector('serialisation-modal');
      if (serialisationModal) {
        serialisationModal.reinitialize();
        serialisationModal.show();
      }
    }
  }, {
    key: "initializeCollapsibleRows",
    value: function initializeCollapsibleRows() {
      var collapsibleRow = new _snippets_collapsible_row__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A();
      if (typeof collapsibleRow.init === 'function') {
        collapsibleRow.init();
      } else {
        console.warn('CollapsibleRow does not have an init method.');
      }
    }

    /**
     * Initializes the ProductAccordion.
     * @private
     * @returns {void}
     */
  }, {
    key: "initializeAccordion",
    value: function initializeAccordion() {
      try {
        var prodAccordion = new _snippets_product_accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A();
        if (typeof prodAccordion.init === 'function') {
          prodAccordion.init();
        } else {
          console.warn('ProductAccordion does not have an init method.');
        }
      } catch (error) {
        console.error('Error initializing ProductAccordion:', error);
      }
    }

    /**
     * Initializes the product description links.
     * @private
     * @returns {void}
     */
  }, {
    key: "initializeProductDescriptionLinks",
    value: function initializeProductDescriptionLinks() {
      var _this = this;
      var desktopLinks = document.querySelectorAll('[js-product-description-link]');
      if (desktopLinks) {
        desktopLinks.forEach(function (link) {
          link.addEventListener('click', _this.handleProductDescriptionClick.bind(_this));
        });
      }
    }

    /**
     * Handles the product description click event.
     * @private
     * @param {Event} event - The click event.
     * @returns {void}
     */
  }, {
    key: "handleProductDescriptionClick",
    value: function handleProductDescriptionClick(event) {
      event.preventDefault();
      var openText = document.querySelector('.product-new__description-text--open');
      var closedText = document.querySelector('.product-new__description-text--closed');
      if (openText) openText.classList.toggle('hidden');
      if (closedText) closedText.classList.toggle('hidden');
    }

    /**
     * Initializes the NewLinkedProducts.
     * @private
     * @returns {void}
     */
  }, {
    key: "initializeLinkedProducts",
    value: function initializeLinkedProducts() {
      var productAttributes = window.productattribute || window.productattribute_default;
      if (productAttributes.length !== undefined && (productAttributes[0].options.includes('Color') || productAttributes[0].options.includes('Size'))) return;
      try {
        var newLinkedProducts = new _snippets_new_linked_products__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A();
        if (typeof newLinkedProducts.init === 'function') {
          newLinkedProducts.init();
        } else {
          console.warn('NewLinkedProducts does not have an init method.');
        }
      } catch (error) {
        console.error('Error initializing NewLinkedProducts:', error);
      }
    }

    /**
     * Applies custom styling to the Shopify payment terms if available.
     * Ensures that each DOM element needed exists before proceeding.
     * @private
     * @returns {void}
     */
  }, {
    key: "applyShopifyPaymentTermsStyling",
    value: function applyShopifyPaymentTermsStyling() {
      try {
        var paymentTermsElement = document.querySelector('shopify-payment-terms');
        if (!paymentTermsElement || !paymentTermsElement.shadowRoot) {
          console.warn('Shopify payment terms element or its shadowRoot not found.');
          return;
        }
        var shopPayInstallmentsBanner = paymentTermsElement.shadowRoot.querySelector('shop-pay-installments-banner');
        if (!shopPayInstallmentsBanner || !shopPayInstallmentsBanner.shadowRoot) {
          console.warn('Shop Pay installments banner or its shadowRoot not found.');
          return;
        }
        var style = document.createElement('style');
        style.innerHTML = '.shopify-installments #shopify-installments-cta { text-decoration: none; }';

        // Insert style before the first child for better performance
        shopPayInstallmentsBanner.shadowRoot.insertBefore(style, shopPayInstallmentsBanner.shadowRoot.firstChild);
      } catch (error) {
        console.error('Error applying Shopify Payment Terms styling:', error);
      }
    }
  }]);
}();
/* Listen to the variant change event */
subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
  try {
    var productInfo = new ProductInfo();
    productInfo.init();
  } catch (error) {
    console.error('Error instantiating ProductInfo:', error);
  }
});
document.addEventListener('DOMContentLoaded', function () {
  try {
    var productInfo = new ProductInfo();
    productInfo.init();
  } catch (error) {
    console.error('Error instantiating ProductInfo:', error);
  }
});
/******/ })()
;